// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"1412cfea","31":"8386299e","390":"0c6b2a08","896":"c2396c92"}[chunkId] + ".chunk.js";
};